<template>
  <div>
    <div class="row">
      <div class="col-md-12">

        <div class="form-group">
          <label for="driver-cpf">CPF *</label>
          <input
              v-model="currentDriver.cpf"
              type="text"
              class="form-control"
              id="driver-cpf"
              v-mask="'###.###.###-##'"
              :disabled="isEditing"
          >
        </div>

        <div class="form-group">
          <label for="driver-name">Nome *</label>
          <input
              v-model="currentDriver.name"
              type="text"
              class="form-control"
              id="driver-name"
              aria-describedby="nameHelp"
          >
        </div>

        <div class="form-group">
          <label for="driver-phone">Telefone *</label>
          <input
              v-model="currentDriver.phone"
              type="text"
              class="form-control"
              id="driver-phone"
              v-mask="['(##) ####-####', '(##) #####-####']"
          >
        </div>

        <div class="form-group">
          <label for="driver-category">Categoria do Motorista *</label>
          <input
              v-model="currentDriver.category"
              type="text"
              class="form-control"
              id="driver-category"
              placeholder="Ex: A, B, C, D, E, AB, AC, AD, AE"
          >
        </div>

        <div class="form-group">
          <label for="driver-cnh">CNH</label>
          <Upload
            :is-multiple="false"
            @changeFiles="handleFileUpload($event, 'cnh_file')"
            class="mb-2"
          >
            <div class="upload-text">
              {{ currentDriver.cnh_file && currentDriver.cnh_file.name ? `Arquivo anexado: ${currentDriver.cnh_file.name}` : (driver && driver.cnhFileAttached ? 'CNH anexada — escolher outro arquivo' : 'Escolher arquivo') }}
            </div>
          </Upload>
        </div>
      </div>
    </div>

    <div class="row" v-if="$withPolicy('application', 'drivers/insert_or_update')">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="$emit('cancel')">Cancelar</button>
        <button class="btn btn-primary" @click="save" :disabled="disabledSaveButton">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import EntityProxy from '@/models/EntityProxy'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'
  import Upload from '@/components/shares/specialTag/Upload'

  import { mask } from 'vue-the-mask'

  export default {
    components: { Upload },
    computed: {
      isEditing() {
        return this.driver && this.driver.id
      },
      disabledSaveButton() {
        if (this.accountIsClosed) return true

        const cpfEmpty = !this.currentDriver.cpf || this.currentDriver.cpf.trim() === ''
        const nameEmpty = !this.currentDriver.name || this.currentDriver.name.trim() === ''
        const phoneEmpty = !this.currentDriver.phone || this.currentDriver.phone.trim() === ''
        const categoryEmpty = !this.currentDriver.category || this.currentDriver.category.trim() === ''

        return cpfEmpty || nameEmpty || phoneEmpty || categoryEmpty
      }
    },
    created() {
      if (this.driver)
        this.currentDriver = EntityProxy.clone(this.driver)
      else {
        this.currentDriver = EntityProxy.build({})
      }
    },
    data: () => ({
      currentDriver: {},
      nameModel: 'Driver',
    }),
    directives: { mask },
    methods: {
      handleFileUpload(files, field) {
        if (files && files.length > 0) {
          this.$set(this.currentDriver, field, files[0])
        }
      },
      buildData() {
        const cleanCpf = this.currentDriver.cpf ? this.currentDriver.cpf.replace(/\D/g, '') : null
        const cleanPhone = this.currentDriver.phone ? this.currentDriver.phone.replace(/\D/g, '') : null
        
        const driver = {...this.currentDriver}
        driver.cpf = cleanCpf
        driver.phone = cleanPhone
        
        if (this.currentDriver.cnh_file) {
          const formData = new FormData()
          const snakeDriver = this.$parse.toSnakecase(driver)
          
          Object.keys(snakeDriver).forEach(key => {
            if (snakeDriver[key] !== null && snakeDriver[key] !== undefined) {
              formData.append(key, snakeDriver[key])
            }
          })
          
          return formData
        }
        
        return this.$parse.toSnakecase(driver)
      },
      buildHeaders() {
        if (this.currentDriver.cnh_file) {
          return { 'Content-Type': 'multipart/form-data' }
        }
        return {}
      },
      save() {
        this.asyncTemplateSave(this.currentDriver, {
          after: ({model}) => {
            this.$notify.add('Motorista salvo com Sucesso!')
            this.$emit('saved', model)
            this.currentDriver = model
          }
        })
      },
    },
    mixins: [GetAccount, ModelMapper],
    name: 'FormDriver',
    props: {
      driver: { default: null, type: Object },
    },

  }
</script>

<style scoped>
  .btn {
    min-width: 134px;
  }

  p {
    color: var(--primary-text-color);
  }

  .upload-text {
    text-align: center;
    padding: 25px 0;
    color: var(--text-muted);
  }

</style>
